import { useEffect, useRef, useState } from "react";
import { Pause, Play } from "lucide-react";
import { toast } from "sonner";

// Plays the song from the chosen start point; the playhead moves along the timeline and passed cuts light up.
export const useMusicPlayer = (url, offset, length, active = true) => {
  const audio = useRef(null), raf = useRef(0), [time, setTime] = useState(0), [playing, setPlaying] = useState(false);
  useEffect(() => () => { cancelAnimationFrame(raf.current); audio.current?.pause(); }, []);
  useEffect(() => { audio.current?.pause(); audio.current = null; setPlaying(false); setTime(0); }, [url, offset]);
  useEffect(() => { if (!active && audio.current) { audio.current.pause(); cancelAnimationFrame(raf.current); setPlaying(false); } }, [active]);
  const tick = () => { const a = audio.current; if (!a) return; const t = a.currentTime - offset; if (t >= length) { a.pause(); setPlaying(false); setTime(length); return; } setTime(Math.max(0, t)); raf.current = requestAnimationFrame(tick); };
  const toggle = async () => {
    if (!url) return;
    if (!audio.current) { audio.current = new Audio(url); audio.current.currentTime = offset; }
    if (playing) { audio.current.pause(); cancelAnimationFrame(raf.current); setPlaying(false); return; }
    if (time >= length) audio.current.currentTime = offset;
    try { await audio.current.play(); } catch { audio.current = null; setPlaying(false); toast.error("The music preview could not play. Reload the page and try again."); return; }
    setPlaying(true); raf.current = requestAnimationFrame(tick);
  };
  const seek = t => { if (!audio.current) { audio.current = new Audio(url); } audio.current.currentTime = offset + t; setTime(t); };
  return { time, playing, toggle, seek };
};

export const PlayerBar = ({ player, length, scenes }) => {
  let at = 0;
  const bounds = scenes.map(s => (at += s.cut_seconds || s.seconds)), current = bounds.findIndex(b => player.time < b);
  return <div className="sw-music-player" data-testid="music-preview-player">
    <button type="button" className="sw-icon-btn" onClick={player.toggle} aria-label={player.playing ? "Pause music preview" : "Play music preview"} data-testid="music-preview-toggle">{player.playing ? <Pause size={15}/> : <Play size={15}/>}</button>
    <span className="sw-music-clock" data-testid="music-preview-time">{player.time.toFixed(1)}s / {length.toFixed(1)}s</span>
    {scenes.length > 0 && <span className="sw-music-now" data-testid="music-preview-scene">{current === -1 ? "After the last scene" : `Now: ${scenes[current].title}`}</span>}
  </div>;
};
